import React from 'react';
import { Link } from 'react-router-dom';
import { companyInfo } from '../../data/mock';
import SEO from '../seo/SEO';

const MentionsLegalesPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Mentions Légales | NGL SERVICES"
        description="Mentions légales de NGL SERVICES, vitrier, menuisier et serrurier à Villiers-sur-Marne (94). Éditeur, hébergement, SIREN et informations légales du site menuisiervitrier.fr."
        canonical="/mentions-legales"
      />
      <section className="py-16">
        <div className="container mx-auto px-4 max-w-3xl">
          <h1 className="text-3xl md:text-4xl font-bold text-[hsl(215,25%,15%)] mb-2">Mentions légales</h1>
          <p className="text-muted-foreground mb-8">Informations légales relatives au site menuisiervitrier.fr et à la société NGL SERVICES.</p>

          <div className="space-y-8 text-slate-700 leading-relaxed">
            <div>
              <h2 className="text-xl font-semibold text-[hsl(215,25%,15%)] mb-2">1. Éditeur du site</h2>
              <p>
                Le présent site <strong>menuisiervitrier.fr</strong> est édité par <strong>{companyInfo.name}</strong>,
                entreprise spécialisée dans la vitrerie, la menuiserie extérieure et la serrurerie.
              </p>
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li>Dénomination : NGL SERVICES</li>
                <li>Forme : Auto-entrepreneur (entreprise individuelle)</li>
                <li>Adresse : 27 avenue André Rouy, 94350 Villiers-sur-Marne</li>
                <li>N° SIREN : 992 513 531</li>
                <li>N° TVA intracommunautaire : FR87992513531</li>
                <li>Téléphone : {companyInfo.phone} — Urgences : {companyInfo.phoneEmergency}</li>
                <li>Email : {companyInfo.email || 'comptaglotech@gmail.com'}</li>
              </ul>
              <p className="mt-2">TVA non applicable, article 293 B du Code général des impôts.</p>
            </div>

            <div>
              <h2 className="text-xl font-semibold text-[hsl(215,25%,15%)] mb-2">2. Directeur de la publication</h2>
              <p>Le directeur de la publication est le représentant légal de NGL SERVICES.</p>
            </div>

            <div>
              <h2 className="text-xl font-semibold text-[hsl(215,25%,15%)] mb-2">3. Hébergement</h2>
              <p>
                Le site est hébergé sur une infrastructure cloud sécurisée. Pour toute question relative à
                l'hébergement, vous pouvez contacter l'éditeur à l'adresse email indiquée ci-dessus.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-semibold text-[hsl(215,25%,15%)] mb-2">4. Propriété intellectuelle</h2>
              <p>
                L'ensemble des contenus présents sur le site (textes, images, logos, éléments graphiques, structure)
                est la propriété de NGL SERVICES ou de ses partenaires et est protégé par le droit d'auteur et le droit
                des marques. Toute reproduction, représentation, modification ou exploitation, totale ou partielle, sans
                autorisation écrite préalable est interdite et constituerait une contrefaçon sanctionnée par le Code de
                la propriété intellectuelle.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-semibold text-[hsl(215,25%,15%)] mb-2">5. Responsabilité</h2>
              <p>
                NGL SERVICES s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur ce site,
                dont elle se réserve le droit de corriger le contenu à tout moment. Toutefois, NGL SERVICES ne peut
                garantir l'exactitude, la précision ou l'exhaustivité des informations mises à disposition. Les tarifs
                et prestations indiqués sont donnés à titre indicatif et font l'objet d'un devis personnalisé et gratuit.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-semibold text-[hsl(215,25%,15%)] mb-2">6. Liens hypertextes</h2>
              <p>
                Le site peut contenir des liens vers d'autres sites. NGL SERVICES n'exerce aucun contrôle sur ces sites
                et décline toute responsabilité quant à leur contenu.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-semibold text-[hsl(215,25%,15%)] mb-2">7. Données personnelles</h2>
              <p>
                Le traitement de vos données personnelles est décrit dans notre{' '}
                <Link to="/politique-confidentialite" className="text-[hsl(207,78%,42%)] hover:underline">politique de confidentialité</Link>.
                Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression de vos données.
              </p>
            </div>
          </div>

          <div className="mt-10">
            <Link to="/contact" className="text-[hsl(207,78%,42%)] hover:underline">Nous contacter</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MentionsLegalesPage;
